module.exports = __webpack_public_path__ + "img/icon-run.4176234c.svg";